<template>
  <wrap-container v-if="vista && vista.config">
    <step-counter :paso="vista.config.paso" />
    <p
      id="antetitulo"
      class="antetitulo light oscuro"
      v-if="vista.config.antetitulo"
      v-safe-html="vista.config.antetitulo"
    />
    <p
      id="titulo"
      class="titulo p32 medium oscuro"
      v-safe-html="vista.config.titulo"
    />
    <p
      id="subtitulo"
      class="titulo oscuro"
      v-safe-html="vista.config.subtitulo"
    />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import StepCounter from "@/components/core/StepCounter";
export default {
  name: "StepHeader",
  components: { WrapContainer, StepCounter },
  data() {
    return {
      vista: null
    };
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
  }
};
</script>
